export default __webpack_public_path__ + "static/media/download (2).0c15bf90.png";